import { useComparador } from '../context/ComparadorContext';
import { useNavigate } from 'react-router-dom';
import { BarChartHorizontal } from 'lucide-react';
import { toast } from 'react-toastify';

export default function IconeComparador() {
  const { imoveisSelecionados } = useComparador();
  const navigate = useNavigate();

  const vazio = imoveisSelecionados.length === 0;

  const handleClick = () => {
    if (vazio) {
      toast.info('Adicione imóveis ao comparador antes de acessar.');
    } else {
      navigate('/comparar-imoveis');
    }
  };

  return (
    <div
      onClick={handleClick}
      title="Comparador de imóveis"
      className={`fixed top-6 right-6 lg:right-[60px] z-50 p-3 rounded-full shadow-lg border transition-all duration-200 ${
        vazio
          ? 'bg-gray-200 border-gray-300 text-gray-400 cursor-default opacity-80'
          : 'bg-blue-600 border-blue-700 text-white cursor-pointer hover:shadow-xl'
      }`}
    >
      <div className="relative">
        <BarChartHorizontal size={24} />
        <span className="absolute -top-2 -right-2 bg-white text-blue-600 text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
          {imoveisSelecionados.length}
        </span>
      </div>
    </div>
  );
}
